
    import { TimePicker } from '@alifd/next';
    import type { TimePickerProps } from '@alifd/next/types/time-picker';
    import wrapper from './next-wrapper';

    export type BLProFormTimePickerProps =TimePickerProps;

    const BLProFormTimePicker = wrapper<BLProFormTimePickerProps>(TimePicker, 'BLProFormTimePicker');

    export default BLProFormTimePicker;
